/**
 * Subscription object represents authentication-related API endpoints and their methods.
 */
const Subscription = {
  /**
   * Endpoint for admin subscription list.
   * @memberof Subscription
   * @type {object}
   * @property {string} url - The URL for admin login.
   * @property {string} method - The HTTP method for admin login (POST).
   */

  adminGetSubscriptionList: {
    url: "/admin/subscription",
    method: "GET",
  },
  getTransactionHistory: {
    url: "/admin/transaction",
    method: "GET",
  },
  adminGetUserSubscriptionList: (id) => ({
    url: `admin/user/${id}/subscription`,
    method: "GET",
  }),
  adminGetUserTransactionList: (id) => ({
    url: `admin/user/${id}/transaction`,
    method: "GET",
  }),
};

// Export the Subscription object for use in other modules
export default Subscription;
